import { render, staticRenderFns } from "./licensesetting.vue?vue&type=template&id=3b0dfe6e&"
import script from "./licensesetting.vue?vue&type=script&lang=js&"
export * from "./licensesetting.vue?vue&type=script&lang=js&"
import style0 from "./licensesetting.vue?vue&type=style&index=0&id=3b0dfe6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports